<template>
  <div class="createOrEditRoot">
  <!-- 创建 / 编辑共用暖灰表单壳，区块顺序对齐详情 v5 -->
  <div class="resourceFormPage divContainer genericResourceModule">
    <div v-if="loading" v-loading="loading" class="fullContainer" />
    <div v-else class="resourceFormPage__layout">
      <el-form
        label-position="top"
        size="small"
        class="resourceFormPage__form"
        :model="ruleForm"
        :rules="formRules"
        :validate-on-rule-change="false"
        ref="ruleForm"
      >
        <div class="resourceFormPage__headerDock">
          <header
            class="resourceFormPage__actionBar"
            :class="{ 'resourceFormPage__actionBar--typeOpen': typePanelVisible }"
          >
            <div class="resourceFormPage__lead">
              <h1 class="resourceFormPage__pageTitle">
                {{ isCreate ? '创建资源' : '编辑资源' }}
                <span
                  v-if="isCreate && completionPendingCount > 0"
                  class="resourceFormPage__pendingBadge"
                >
                  {{ completionPendingCount }} 项待完成
                </span>
              </h1>
              <template v-if="isCreate">
                <button
                  type="button"
                  class="resourceFormPage__typeTrigger"
                  data-section-id="header"
                  data-field-key="assetType"
                  :class="{ 'resourceFormPage__typeTrigger--open': typePanelVisible }"
                  :title="ruleForm.assetType || '请选择资源类型'"
                  :aria-expanded="typePanelVisible ? 'true' : 'false'"
                  aria-haspopup="listbox"
                  @click.stop="toggleTypePanel"
                >
                  <span class="resourceFormPage__typeTriggerLabel">资源类型</span>
                  <span
                    class="resourceFormPage__typeTriggerValue link-font-mono"
                    :class="{ 'resourceFormPage__typeTriggerValue--empty': !hasSelectedType }"
                  >
                    {{ typeTriggerLabel }}
                  </span>
                  <i class="el-icon-arrow-down resourceFormPage__typeTriggerChevron" aria-hidden="true" />
                </button>
              </template>
              <span v-else class="resourceFormPage__typeReadonly">{{ ruleForm.assetType }}</span>
              <el-form-item v-show="false" prop="assetType">
                <el-input v-model="ruleForm.assetType" />
              </el-form-item>
            </div>
            <div class="resourceFormPage__actions">
              <button type="button" class="resourceFormPage__btn resourceFormPage__btn--ghost" @click="goBack">
                取消
              </button>
              <button
                type="button"
                class="resourceFormPage__btn resourceFormPage__btn--primary"
                :disabled="saving"
                @click="submitForm()"
              >
                {{ saving ? '保存中' : '保存' }}
              </button>
            </div>
          </header>

          <transition name="linkTypePanelFloat">
            <div
              v-if="isCreate && typePanelVisible"
              class="resourceFormPage__typeFloatLayer"
              @click.stop
            >
              <generic-resource-type-picker-panel
                :type-options="typeOptions"
                :value="ruleForm.assetType"
                @select="selectAssetType"
              />
            </div>
          </transition>
        </div>

        <button
          v-if="isCreate && typePanelVisible"
          type="button"
          class="resourceFormPage__typeBackdrop"
          aria-label="关闭类型选择"
          tabindex="-1"
          @click="typePanelVisible = false"
        />

        <main ref="formMain" class="resourceFormPage__main main">
          <generic-resource-form-shell
            ref="formShell"
            :rule-form="ruleForm"
            :unlock-data="unlockData"
            :is-create="isCreate"
            :data-options="dataOptions"
            :show-completion-status="isCreate"
            governance-profile="link_default"
            @url-uploaded="onUrlUploaded"
            @url-cleared="onUrlCleared"
            @cover-uploaded="onCoverUploaded"
            @cover-cleared="onCoverCleared"
            @completion-changed="onCompletionChanged"
          />
        </main>
      </el-form>
    </div>
  </div>
  </div>
</template>

<script>
import { stickerEditZipUrl, stickerInitializationLocked, stickerReuploadReady } from './form/stickerInitialization'

import { getAllCategory } from "../../../api/comment";
import { getAllDataList } from "../../../api/classifyManage";
import { getLockGroupList } from "../../../api/unlockGroup";
import { findFreeUnlockGroupId } from "./freeUnlockGroup";
import {
  addGenericResource,
  updateGenericResource,
  getGenericResourceById,
  listAllWallpaperType,
} from "../../../api/genericResource";
import {
  normalizeGenericResourceDetail,
  toWallpaperCo,
} from "./genericResourceAdapter";
import { parseExtaObject } from "./form/genericResourceExtaUtils";
import { resolveCollectionThumbUrl } from "./genericResourceInfoHelper";
import GenericResourceFormShell from "./form/GenericResourceFormShell.vue";
import GenericResourceTypePickerPanel from "./form/GenericResourceTypePickerPanel.vue";
import {
  buildResourceUrlFormRules,
  buildWebCoverFormRules,
  isNonFileType,
} from "./genericResourceUploadRules";
import { recordRecentAssetType } from "./form/genericResourceTypeRecent";
import { computeGenericResourceCompletion } from "./form/genericResourceFormCompletion";
import { buildGenericResourceSaveValidationMessage } from "./form/genericResourceSaveValidationMessage";
import { resolveLayoutBackTo, buildLocationWithBackTo } from "../../../utils/layoutNavigation";
export default {
  name: "createOrEdit",
  data() {
    return {
      isCreate: true,
      saving: false,
      unlockData: {
        dataSetLockGroupList: [{ lockGroupId: "", dataSetId: "" }],
        defaultLockGroupId: "",
      },
      ruleForm: {
        resourceName: "",
        assetType: "",
        key: "",
        thumbUrl: "",
        androidNeglectVersion: "",
        iosNeglectVersion: "",
        jsonConfig: {
          url: "",
          exta: {},
        },
        categoryIdList: [],
        tagVOList: [],
        countryList: {
          isExclude: true,
          countries: [],
        },
        wallpaperAppVersionList: [
          {
            start: "",
            end: "",
            skip: "",
            dataSetId: "",
          },
        ],
      },
      rules: {
        resourceName: [
          { required: true, message: "资源名称不能为空", trigger: "blur" },
        ],
        assetType: [
          { required: true, message: "资源类型不能为空", trigger: "blur" },
        ],
      },
      tagMap: {},
      loading: false,
      dataOptions: [],
      typeOptions: [],
      typePanelVisible: false,
      formBaseline: "",
      skipLeaveGuard: false,
      completionRevision: 0,
      /** 新建时默认选中的「免费解锁」组 id；列表加载前为空。 */
      freeUnlockGroupId: "",
    };
  },
  components: {
    GenericResourceFormShell,
    GenericResourceTypePickerPanel,
  },
  computed: {
    hasSelectedType() {
      return !!String(this.ruleForm.assetType || "").trim();
    },
    typeTriggerLabel() {
      if (!this.hasSelectedType) {
        return "请选择资源类型";
      }
      return this.ruleForm.assetType;
    },
    formRules() {
      return {
        ...this.rules,
        ...buildResourceUrlFormRules(this.ruleForm.assetType),
        ...buildWebCoverFormRules(this.ruleForm.assetType),
      };
    },
    completionPendingCount() {
      void this.completionRevision;
      const shell = this.$refs.formShell;
      if (shell && shell.getCompletionSnapshot) {
        return shell.getCompletionSnapshot().pendingCount || 0;
      }
      return computeGenericResourceCompletion({
        ruleForm: this.ruleForm,
        unlockData: this.unlockData,
        hasSelectedType: this.hasSelectedType,
        typeConfigSnapshot: {},
      }).pendingCount;
    },
  },
  created() {
    this.isCreate = this.$route.path.indexOf("edit") === -1;
    //获取所有的分类信息
    this.getCategoryInfo();
    this.getAllData();
    this.getTypeOptions();
    if (!this.isCreate) {
      //请求编辑信息
      this.getRuleForm();
    } else {
      this.loadFreeUnlockGroup();
      this.$nextTick(() => {
        this.markFormBaseline();
        if (!this.hasSelectedType) {
          this.typePanelVisible = true;
        }
      });
    }
  },
  beforeDestroy() {
    if (this._scrollFormToTopTimer) {
      clearTimeout(this._scrollFormToTopTimer);
      this._scrollFormToTopTimer = null;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.skipLeaveGuard) {
      next();
      return;
    }
    this.confirmLeaveIfDirty().then((ok) => {
      next(ok);
    });
  },
  methods: {
    toggleTypePanel() {
      this.typePanelVisible = !this.typePanelVisible;
    },
    selectAssetType(assetType) {
      if (!assetType) {
        return;
      }
      if (this.ruleForm.assetType === assetType) {
        this.typePanelVisible = false;
        return;
      }
      if (this.hasSelectedType && this.isFormDirty()) {
        this.confirmLeaveIfDirty(
          "切换类型将清空当前未保存内容，确定切换吗？",
          { forRouteLeave: false }
        ).then((ok) => {
          if (!ok) {
            return;
          }
          this.applyAssetType(assetType);
        });
        return;
      }
      this.applyAssetType(assetType);
    },
    resetCreateFormForTypeChange() {
      this.ruleForm.resourceName = "";
      this.ruleForm.thumbUrl = "";
      this.ruleForm.jsonConfig.url = "";
      this.ruleForm.jsonConfig.exta = {};
      this.ruleForm.categoryIdList = [];
      this.ruleForm.tagVOList = [];
      this.ruleForm.countryList = {
        isExclude: true,
        countries: [],
      };
      this.ruleForm.wallpaperAppVersionList = [
        {
          start: "",
          end: "",
          skip: "",
          dataSetId: "",
        },
      ];
      this.unlockData = {
        dataSetLockGroupList: [{ lockGroupId: "", dataSetId: "" }],
        defaultLockGroupId: "",
      };
    },
    loadFreeUnlockGroup() {
      getLockGroupList(
        { pageNum: "", pageSize: "", groupName: "", lockGroupType: "" },
        0
      )
        .then((res) => {
          if (!res || !res.success) {
            return;
          }
          this.freeUnlockGroupId = findFreeUnlockGroupId(res.data);
          this.applyFreeUnlockDefault();
        })
        .catch(() => {
          // 拿不到列表时保持不选，运营照常手选，不挡新建。
        });
    },
    /**
     * 只在新建 stickers 且还没选时填；其他类型可能是付费资源，不替运营默认免费。
     * 列表晚于初始快照返回时同步刷新快照，避免没动过的页面离开时被提示未保存。
     */
    applyFreeUnlockDefault() {
      if (
        !this.isCreate ||
        this.ruleForm.assetType !== "stickers" ||
        !this.freeUnlockGroupId ||
        this.unlockData.defaultLockGroupId
      ) {
        return;
      }
      const pristine = !this.isFormDirty();
      this.unlockData.defaultLockGroupId = this.freeUnlockGroupId;
      if (pristine) {
        this.$nextTick(() => this.markFormBaseline());
      }
    },
    applyAssetType(assetType) {
      const switching = this.hasSelectedType && this.ruleForm.assetType !== assetType;
      if (switching) {
        this.resetCreateFormForTypeChange();
      }
      this.ruleForm.assetType = assetType;
      recordRecentAssetType(assetType);
      this.applyFreeUnlockDefault();
      this.onAssetTypeChange();
      this.typePanelVisible = false;
      this.$nextTick(() => {
        this.markFormBaseline();
        this.scrollFormToTop();
      });
    },
    /**
     * 切换资源类型后回到页面顶部。
     * 实际滚动容器可能是内层 main 或 Layout 的 el-main（.layoutMain），需沿祖先链一并复位；
     * 类型面板关闭动效会触发布局重排，故在 rAF 与动效结束后各执行一次 instant 回顶。
     */
    scrollFormToTop() {
      const reset = () => {
        const seen = new Set();
        const resetEl = (el) => {
          if (!el || seen.has(el)) {
            return;
          }
          seen.add(el);
          if (typeof el.scrollTop === "number" && el.scrollTop !== 0) {
            el.scrollTop = 0;
          }
        };

        let node = this.$refs.formMain;
        while (node) {
          resetEl(node);
          node = node.parentElement;
        }

        resetEl(document.documentElement);
        resetEl(document.body);
        if (window.scrollY !== 0) {
          window.scrollTo(0, 0);
        }
      };

      this.$nextTick(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(reset);
        });
      });

      if (this._scrollFormToTopTimer) {
        clearTimeout(this._scrollFormToTopTimer);
      }
      this._scrollFormToTopTimer = window.setTimeout(reset, 320);
    },
    onUrlUploaded() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate(["jsonConfig.url"]);
      }
    },
    onUrlCleared() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate(["jsonConfig.url"]);
      }
      this.onCompletionChanged();
    },
    onCoverUploaded() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate(["thumbUrl"]);
      }
      this.onCompletionChanged();
    },
    onCoverCleared() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate(["thumbUrl"]);
      }
      this.onCompletionChanged();
    },
    onCompletionChanged() {
      this.completionRevision += 1;
    },
    onAssetTypeChange() {
      if (this.isCreate) {
        this.ruleForm.thumbUrl = "";
        this.ruleForm.jsonConfig.url = "";
        this.ruleForm.jsonConfig.exta = {};
      }
      this.$nextTick(() => {
        if (this.$refs.formShell) {
          this.$refs.formShell.resetBasicForm();
        }
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    mergeExtaBeforeSave() {
      const shell = this.$refs.formShell;
      const payload = shell && shell.buildExtaPayload ? shell.buildExtaPayload() : {};
      if (isNonFileType(this.ruleForm.assetType)) {
        this.ruleForm.jsonConfig.exta = payload;
        return;
      }
      const base = parseExtaObject(this.ruleForm.jsonConfig.exta);
      const next = { ...base, ...payload };
      // 产品：动作写 MET，合集不再汇总卡路里——保存时清掉旧 calories / total_calories
      if (this.ruleForm.assetType === 'workout_action') {
        delete next.calories;
      }
      if (this.ruleForm.assetType === 'workout_collection') {
        delete next.total_calories;
      }
      this.ruleForm.jsonConfig.exta = next;
      if (this.ruleForm.assetType === 'workout_collection') {
        const cover = resolveCollectionThumbUrl(this.ruleForm.jsonConfig.exta);
        if (cover) {
          this.ruleForm.thumbUrl = cover;
        }
      }
    },
    filterDataSetLockGroupList(list) {
      return (list || []).filter((entry) => entry.lockGroupId !== '' && entry.dataSetId !== '');
    },
    normalizeNeglectVersionForSave(value) {
      if (Array.isArray(value)) {
        if (!value.length || value[0] === '') {
          return [];
        }
        return value.slice();
      }
      const parts = String(value || '').split(',');
      if (parts[0] === '') {
        return [];
      }
      return parts;
    },
    normalizeCategoryIdListForSave(categoryIdList) {
      if (typeof categoryIdList === 'string') {
        return categoryIdList;
      }
      return categoryIdList.map((res) => this.tagMap[res]).join(',');
    },
    buildWallpaperCoForSave({ id } = {}) {
      this.mergeExtaBeforeSave();
      const saveFields = {
        defaultLockGroupId: this.unlockData.defaultLockGroupId,
        dataSetLockGroupList: this.filterDataSetLockGroupList(
          this.unlockData.dataSetLockGroupList
        ),
        categoryIdList: this.normalizeCategoryIdListForSave(this.ruleForm.categoryIdList),
        androidNeglectVersion: this.normalizeNeglectVersionForSave(
          this.ruleForm.androidNeglectVersion
        ),
        iosNeglectVersion: this.normalizeNeglectVersionForSave(this.ruleForm.iosNeglectVersion),
        appVersionDataSetList: this.setAppVersion(this.ruleForm.wallpaperAppVersionList),
        tagKeySet: this.ruleForm.tagVOList.map((entry) => entry.key),
      };
      if (id != null && id !== '') {
        saveFields.id = id;
      } else {
        saveFields.wallpaperUrlList = [];
        saveFields.wallpaperUrlListAndroid = [];
      }
      return toWallpaperCo({ ...this.ruleForm, ...saveFields });
    },
    captureFormSnapshot() {
      const ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
      const shellSnap =
        this.$refs.formShell && this.$refs.formShell.captureSnapshot
          ? this.$refs.formShell.captureSnapshot()
          : {};
      return JSON.stringify({
        ruleForm,
        unlockData: this.unlockData,
        shellSnap,
      });
    },
    markFormBaseline() {
      this.formBaseline = this.captureFormSnapshot();
    },
    isFormDirty() {
      if (!this.formBaseline) {
        return false;
      }
      return this.captureFormSnapshot() !== this.formBaseline;
    },
    confirmLeaveIfDirty(message, options = {}) {
      const forRouteLeave = options.forRouteLeave !== false;
      if (this.skipLeaveGuard || !this.isFormDirty()) {
        return Promise.resolve(true);
      }
      return this.$confirm(
        message || "当前页面有未保存的修改，离开后将丢失。确定要离开吗？",
        "未保存的更改",
        {
          confirmButtonText: forRouteLeave ? "离开" : "确定",
          cancelButtonText: "继续编辑",
          type: "warning",
        }
      )
        .then(() => {
          if (forRouteLeave) {
            this.skipLeaveGuard = true;
          }
          return true;
        })
        .catch(() => false);
    },
    getCategoryInfo(name = "") {
      getAllCategory(name, 21).then((res) => {
        let tagMap = {};
        if (res.success) {
          res.data.forEach((element) => {
            tagMap[element.name] = element.id;
          });
          if (JSON.stringify(this.tagMap) === "{}") {
            this.tagMap = tagMap;
          }
        }
      });
    },
    getAllData() {
      getAllDataList().then((res) => {
        if (res.success) {
          this.dataOptions = res.data;
        }
      });
    },
    getTypeOptions() {
      listAllWallpaperType().then((res) => {
        if (res.success && res.data) {
          this.typeOptions = res.data;
        }
      });
    },
    getRuleForm() {
      this.loading = true;
      let extaPayload = null;
      getGenericResourceById({ id: this.$route.params.id })
        .then((res) => {
          if (res.success) {
            const detail = normalizeGenericResourceDetail(res.data);
            const extaObj = parseExtaObject(detail.jsonConfig && detail.jsonConfig.exta);
            extaPayload = extaObj;
            detail.jsonConfig.exta = extaObj;
            if (
              detail.assetType === 'workout_collection' &&
              !detail.thumbUrl
            ) {
              const cover = resolveCollectionThumbUrl(extaObj);
              if (cover) {
                detail.thumbUrl = cover;
              }
            }
            this.ruleForm = {
              ...this.ruleForm,
              ...detail,
              jsonConfig: {
                ...this.ruleForm.jsonConfig,
                ...(detail.jsonConfig || {}),
                exta: extaObj,
              },
            };
            if (detail.assetType === 'stickers') {
              this.ruleForm.jsonConfig.url = stickerEditZipUrl(this.ruleForm.jsonConfig);
            }
            if (
              detail.wallpaperAppVersionList &&
              detail.wallpaperAppVersionList.length > 0
            ) {
              this.ruleForm.wallpaperAppVersionList = this.getAppVersion(
                detail.wallpaperAppVersionList
              );
            } else {
              this.ruleForm.wallpaperAppVersionList = [
                {
                  start: "",
                  end: "",
                  skip: "",
                  dataSetId: "",
                },
              ];
            }

            this.ruleForm.androidNeglectVersion =
              (detail.androidNeglectVersion || []).join(",");

            this.ruleForm.iosNeglectVersion =
              (detail.iosNeglectVersion || []).join(",");

            this.unlockData.dataSetLockGroupList =
              detail.wallpaperLockGroupVOList &&
              detail.wallpaperLockGroupVOList.length > 0
                ? detail.wallpaperLockGroupVOList
                : [{ lockGroupId: "", dataSetId: "" }];

            this.unlockData.defaultLockGroupId = detail.defaultLockGroupId;
            this.ruleForm.categoryIdList = (detail.categoryList || []).map((e) => {
              return e.name;
            });
          }
        })
        .finally(() => {
          this.loading = false;
          // formShell 在 v-else 里，loading 结束前 ref 不存在；须在壳挂载后再灌 exta
          this.$nextTick(() => {
            if (extaPayload != null && this.$refs.formShell) {
              this.$refs.formShell.loadFromExta(extaPayload);
            }
            this.$nextTick(() => {
              this.markFormBaseline();
            });
          });
        });
    },
    createGenericResource() {
      const unresolvedCategory = (Array.isArray(this.ruleForm.categoryIdList) ? this.ruleForm.categoryIdList : [])
        .find((name) => name && this.tagMap[name] == null)
      if (unresolvedCategory) {
        this.$message.error('分类映射未就绪或无效，请稍后重试')
        return
      }
      const data = this.buildWallpaperCoForSave();
      var form = new FormData();
      form.append("dataJson", JSON.stringify({ WallpaperCo: data }));
      return addGenericResource(form)
        .then((response) => {
          if (response.success) {
            this.skipLeaveGuard = true;
            this.$message.success("新建成功");
            const resourceId = response.data;
            if (resourceId != null && resourceId !== "") {
              this.$router.push(
                buildLocationWithBackTo(
                  `/resource/link/info/${resourceId}`,
                  this.$route.query && this.$route.query.backTo
                )
              );
            } else {
              const backTo = resolveLayoutBackTo(
                this.$route,
                "/resource/link/list"
              );
              this.$router.push(backTo || "/resource/link/list");
            }
          }
        })
        .catch(() => {
          // 保存失败不清空运营已填的训练配置；仅提示由 request 拦截器处理
        });
    },
    submitForm() {
      if (stickerInitializationLocked(this.ruleForm) && !stickerReuploadReady(this.ruleForm)) {
        this.$message.warning('贴纸初始化尚未完成，请等待、重试，或在失败后上传新的 zip 再保存')
        return
      }
      if (this.saving) {
        return
      }
      const shell = this.$refs.formShell
      let shellError = null
      let mainValid = false

      const shellPromise =
        shell && shell.validateAll
          ? shell.validateAll().catch((err) => {
              const msg =
                typeof err === 'string' && err.trim()
                  ? err.trim()
                  : err && err.message && String(err.message).trim()
                    ? String(err.message).trim()
                    : ''
              shellError = msg || '训练资源配置未填完整'
            })
          : Promise.resolve()

      const mainPromise = new Promise((resolve) => {
        this.$refs.ruleForm.validate((valid) => {
          mainValid = valid
          resolve()
        })
      })

      Promise.all([shellPromise, mainPromise]).then(() => {
        if (shellError || !mainValid || !this.hasSelectedType) {
          const completion =
            shell && shell.getCompletionSnapshot
              ? shell.getCompletionSnapshot()
              : computeGenericResourceCompletion({
                  ruleForm: this.ruleForm,
                  unlockData: this.unlockData,
                  hasSelectedType: this.hasSelectedType,
                  typeConfigSnapshot: {},
                });
          // 合集等细则校验失败时 pendingCount 可能为 0；必须优先展示 shellError，避免「请完成 0 项」
          this.$message({
            type: 'error',
            message: buildGenericResourceSaveValidationMessage({
              shellError,
              pendingCount: completion.pendingCount || 0,
            }),
          });

          this.$nextTick(() => {
            if (!this.hasSelectedType) {
              this.typePanelVisible = true
              const trigger = this.$el.querySelector('[data-field-key="assetType"]')
              if (trigger && trigger.scrollIntoView) {
                trigger.scrollIntoView({ behavior: 'smooth', block: 'center' })
              }
              return
            }

            if (shell && shell.scrollToFirstError) {
              const target = shell.scrollToFirstError()
              if (target && target.sectionId === 'header') {
                this.typePanelVisible = true
              }
              if (
                !target &&
                shellError &&
                (shell.typeConfigValidationFailed || shell.schemaValidationFailed) &&
                shell.scrollToTypeConfig
              ) {
                shell.scrollToTypeConfig()
              }
              return
            }

            if (
              shellError &&
              shell &&
              (shell.typeConfigValidationFailed || shell.schemaValidationFailed) &&
              shell.scrollToTypeConfig
            ) {
              shell.scrollToTypeConfig()
            }
          })
          return
        }

        this.saving = true
        const finishSaving = () => {
          this.saving = false
        }
        if (this.isCreate) {
          Promise.resolve(this.createGenericResource()).finally(finishSaving)
        } else {
          const unresolvedCategory = (Array.isArray(this.ruleForm.categoryIdList) ? this.ruleForm.categoryIdList : [])
            .find((name) => name && this.tagMap[name] == null)
          if (unresolvedCategory) {
            this.saving = false
            this.$message.error('分类映射未就绪或无效，请稍后重试')
            return
          }
          const data = this.buildWallpaperCoForSave({ id: this.$route.params.id });
          var form = new FormData();
          form.append("dataJson", JSON.stringify({ WallpaperCo: data }));
          updateGenericResource(form)
            .then((res) => {
              if (res.success) {
                this.skipLeaveGuard = true;
                this.$message.success("保存成功");
                this.$router.push(
                  buildLocationWithBackTo(
                    `/resource/link/info/${this.$route.params.id}`,
                    this.$route.query && this.$route.query.backTo
                  )
                );
              }
            })
            .catch(() => {
              // 保存失败不清空运营已填的训练配置；仅提示由 request 拦截器处理
            })
            .finally(finishSaving)
        }
      });
    },
    setAppVersion(data) {
      var list = JSON.parse(JSON.stringify(data));
      for (let i = list.length - 1; i >= 0; i--) {
        list[i]["skip"] = list[i]["skip"].split(",");
        if (list[i].dataSetId != "0" && !list[i].dataSetId) {
          list.splice(i, 1);
        }
      }
      return list;
    },
    getAppVersion(data) {
      data.forEach((element) => {
        element.skip = element.skip.join(",");
      });
      return data;
    },
    goBack() {
      this.confirmLeaveIfDirty().then((ok) => {
        if (ok) {
          const backTo = resolveLayoutBackTo(this.$route, "/resource/link/list");
          if (backTo) {
            this.$router.push(backTo);
          } else {
            this.$router.back();
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.createOrEditRoot {
  height: 100%;
}

.resourceFormPage__form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.resourceFormPage__lead {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  min-width: 0;
  flex: 1;
}

.resourceFormPage__headerDock {
  position: sticky;
  top: 0;
  z-index: 40;
  flex-shrink: 0;
}

.resourceFormPage__headerDock .resourceFormPage__actionBar {
  position: relative;
  top: auto;
  z-index: 2;
}

.resourceFormPage__typeBackdrop {
  position: fixed;
  inset: 0;
  z-index: 35;
  margin: 0;
  padding: 0;
  border: none;
  background: rgba(15, 23, 42, 0.08);
  cursor: default;
}

.resourceFormPage__typeFloatLayer {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 3;
}

.resourceFormPage__actionBar--typeOpen,
html[data-cms-theme="classic"] .resourceFormPage__actionBar.resourceFormPage__actionBar--typeOpen {
  border-bottom: none;
  box-shadow: none;
}

.resourceFormPage__headerDock:has(.resourceFormPage__typeFloatLayer) {
  background: var(--link-card-surface, #fff);
}

.linkTypePanelFloat-enter-active,
.linkTypePanelFloat-leave-active {
  transition:
    opacity 0.22s ease,
    transform 0.26s cubic-bezier(0.16, 1, 0.3, 1);
}

.linkTypePanelFloat-enter,
.linkTypePanelFloat-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.resourceFormPage__typeTrigger {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 220px;
  max-width: min(420px, 100%);
  padding: 6px 12px;
  border: 1px solid var(--link-line-strong, #e0e0e0);
  border-radius: 8px;
  background: var(--link-field-bg, #fafafa);
  color: var(--link-ink-secondary);
  font-family: var(--link-font-family);
  font-size: var(--link-text-sm);
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    box-shadow 0.15s ease;
}

.resourceFormPage__typeTrigger:hover,
.resourceFormPage__typeTrigger--open {
  border-color: var(--link-accent, #10a37f);
  background: var(--link-accent-bg, #f0fdf9);
  box-shadow: var(--link-focus-ring, 0 0 0 3px rgba(16, 163, 127, 0.12));
}

.resourceFormPage__typeTriggerLabel {
  flex-shrink: 0;
  color: var(--link-ink-muted, #737373);
  font-size: var(--link-text-xs, 12px);
}

.resourceFormPage__typeTriggerValue {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  color: var(--link-ink, #171717);
  font-size: var(--link-text-sm);
}

.resourceFormPage__typeTriggerValue--empty {
  color: var(--link-placeholder, #a3a3a3);
  font-style: normal;
}

.resourceFormPage__typeTriggerChevron {
  flex-shrink: 0;
  font-size: 12px;
  color: var(--link-ink-muted, #a3a3a3);
  transition: transform 0.2s ease;
}

.resourceFormPage__typeTrigger--open .resourceFormPage__typeTriggerChevron {
  transform: rotate(180deg);
}

.resourceFormPage__typeReadonly {
  font-size: var(--link-text-sm);
  color: var(--link-text-muted, #6b6560);
  padding: 4px 10px;
  border-radius: 6px;
  background: var(--link-field-bg, #f3f0ea);
  border: 1px solid var(--link-line-strong, #e5dfd6);
}

.divContainer {
  height: 100%;
}

.fullContainer {
  width: 100%;
  height: 100%;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.main {
  padding: 20px;
}

.card {
  margin-bottom: 20px;
}

.formItemStyle {
  width: 100%;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contentItem {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.contentIcon {
  margin-right: 10px;
  cursor: pointer;
  font-size: var(--link-icon-md);
}

.smallFont {
  font-size: var(--link-text-sm);
}

.componentItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.resourcesComponent {
  margin-bottom: 10px;
}

.resourcesComponent:last-child {
  margin-bottom: 0;
}

.imgContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 350px;
}

.bottomContainer {
  width: 100%;
  height: 50px;
  background-color: var(--link-card-surface, #f7f4ef);
  border-top: 1px solid var(--link-line-strong, #e5dfd6);
  box-shadow: none;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px;
}

.addIcon {
  font-size: var(--link-icon-md);
  color: greenyellow;
  cursor: pointer;
}

.deleteIcon {
  font-size: var(--link-icon-md);
  color: red;
  cursor: pointer;
}

::v-deep .imgdeleteIcon {
  position: absolute;
  top: -8px;
  right: -8px;
}

.updateContainer {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.updateContainer > img {
  /* width: auto;
    height: auto; */
  max-width: 80%;
  max-height: 80%;
}

.updateMask {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.updateButton {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.dataActive {
  color: #569df6;
}

.el-tag {
  margin-right: 10px;
}

.hide {
  display: none;
}

.updateFont {
  width: 80px;
  background-color: var(--link-field-bg, #f3f0ea);
  text-align: center;
  font-size: var(--link-text-sm);
  border-radius: 5px;
  padding: 5px 10px;
}

.tagContainer {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}

.tagContainer::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

::v-deep .avatar-uploader-icon {
  font-size: var(--link-icon-xl);
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

::v-deep .avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: contain;
  position: relative;
}

::v-deep .el-input-group__append,
.el-input-group__prepend {
  background-color: #46a0fc;
  color: #ffffff;
  border: 1px solid #46a0fc;
}

::v-deep .el-form-item--mini > .el-form-item__label {
  font-size: var(--link-text-sm);
}

::v-deep .el-dialog__body {
  padding: 10px 20px;
}

::v-deep .el-tag {
  cursor: pointer;
  height: auto;
  white-space: normal;
}

.createOrEdit__uploadIcon {
  font-size: var(--link-icon-hero);
  color: #5e9ef5;
}

.createOrEdit__uploadRemove {
  position: absolute;
  width: 20px;
  top: -8px;
  cursor: pointer;
  font-weight: var(--link-font-semibold);
  font-size: var(--link-text-xl);
}

.resourceFormPage__pageTitle {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.resourceFormPage__pendingBadge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  background: rgba(217, 119, 6, 0.12);
  font-size: 12px;
  font-weight: 600;
  color: #b45309;
}
</style>

<style>
@import './linkListTheme.css';
@import './linkModuleSurfaces.css';
@import './linkTypography.css';
@import './resourceFormPage.css';
@import './linkFormSurfaces.css';

.linkFormBasic__urlField {
  margin-bottom: 0;
}

.linkFormBasic__urlField >>> .el-form-item__content {
  line-height: 0;
}
</style>
